import React from 'react';
import { FadeIn } from './FadeIn';
import { CheckCircle2, XCircle } from 'lucide-react';
export function WhoIsItFor() {
  return <section className="bg-cream py-20 px-6" data-id="element-216">
      <div className="max-w-6xl mx-auto" data-id="element-217">
        <div className="grid md:grid-cols-2 gap-12" data-id="element-218">
          <FadeIn data-id="element-219">
            <div className="bg-white p-10 rounded-3xl shadow-xl border-t-8 border-green-500 h-full" data-id="element-220">
              <h3 className="text-3xl font-bold text-navy mb-8 text-center" data-id="element-221">
                Este sistema ES para ti si:
              </h3>
              <ul className="space-y-6" data-id="element-222">
                {['Tienes más de 55 años y vives en EE. UU.', "Quieres dejar tus asuntos en orden para no ser una 'carga' para tus seres queridos.", 'Tienes miles de fotos mezcladas con documentos y quieres recuperar el control.', 'Eres un usuario de tecnología básica (sabes usar WhatsApp y Facebook pero te pierdes con archivos).'].map((text, i) => <li key={i} className="flex items-start gap-4" data-id="element-223">
                    <CheckCircle2 className="w-8 h-8 text-green-500 flex-shrink-0 mt-1" data-id="element-224" />
                    <p className="text-xl text-charcoal" data-id="element-225">{text}</p>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-226">
            <div className="bg-white p-10 rounded-3xl shadow-xl border-t-8 border-red-500 h-full" data-id="element-227">
              <h3 className="text-3xl font-bold text-navy mb-8 text-center" data-id="element-228">
                Este sistema NO es para ti si:
              </h3>
              <ul className="space-y-6" data-id="element-229">
                {['Eres un experto en informática o ingeniero de sistemas.', 'No tienes interés en preservar tu legado familiar para las futuras generaciones.', 'Buscas una solución compleja de ciberseguridad corporativa.'].map((text, i) => <li key={i} className="flex items-start gap-4" data-id="element-230">
                    <XCircle className="w-8 h-8 text-red-500 flex-shrink-0 mt-1" data-id="element-231" />
                    <p className="text-xl text-charcoal" data-id="element-232">{text}</p>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}